import type React from 'react';
import { useEffect, useState } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import './ScrollIndicator.css';

function calcScrollRange(): [number, number] {
  const hero = document.getElementById('hero-section');
  const docH = document.documentElement.scrollHeight - window.innerHeight;
  if (!hero || docH <= 0) return [0, 1];
  return [hero.offsetTop / docH, 1];
}

export default function ScrollIndicator(): React.JSX.Element {
  const [range, setRange] = useState<[number, number]>(calcScrollRange);

  useEffect(() => {
    const onResize = () => setRange(calcScrollRange());
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const { scrollYProgress } = useScroll();
  const scaleY = useTransform(scrollYProgress, [range[0], range[1]], [0, 1], { clamp: true });

  return (
    <div className="scroll-indicator" aria-hidden="true">
      <div className="scroll-indicator__track" />
      <motion.div className="scroll-indicator__bar" style={{ scaleY, originY: 0 }} />
    </div>
  );
}
